<template>
<div class="comparison">
    <Card
        label="Provided by Subject"
        :data="data.candidate"
        :compareData="data.referee"
        :showMark="true"
    />
    <Card
        label="Provided by Referee"
        :data="data.referee"
        :compareData="data.candidate"
    />
</div>
</template>

<script>
import Card from "./components/card";

export default {
    name: 'comparison',
    components: {
        Card,
    },
    props: {
        data: {
            type: Object,
            required: true,
        }
    }
}
</script>

<style lang="scss" scoped>
.comparison {
    display: flex;
    gap: 64px;
}
</style>